import {useState} from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idAnswersCreateType3 } from '../../../adminSlice';

const AddInputFormsForAnswersType3  = (props) => {

            
        const [userInputContent, setUserInputContent] = useState('');
       
        const [userInputValue, setUserInputValue] = useState('');

const { dispatch } = props;
  
 // CLICK OK
const onSend = () => {
        
        const item = {
            answer_content: userInputContent,
            
            answer_right: Number(userInputValue),

            question_id: props.adminState.selectedQuestion,
            //quiz_id: props.adminState.selectedQuize
            
        }
        console.log(item);
        dispatch(idAnswersCreateType3(item));  
}
// ENTER INPUT
const handleUserInputContent = (e) => {

            setUserInputContent(e.target.value);

}

const handleUserInputValue = (e) => {

            setUserInputValue(e.target.value);

}




// CLOSE FORM
const onClose = () => {

    dispatch(closeInputForms());

}

   

     
        return(
            <div className="InputFormsForQuizes">
                           


             <p>Создать новый ответ:</p>
             <form>
             
                 <label>
                     Текст бокса</label>
                 <textarea  onChange={handleUserInputContent} 
                 ></textarea>
                 


                 <label>
                     Правдивое утверждение(100/0-да/нет)</label>
                 <input id="value" type="text"  onChange={handleUserInputValue} 
                 />
                


                 



             </form>
             <button onClick={onSend}>OK</button>
             <button onClick={onClose}>Отмена</button>
            </div>
        )
     
       
     

        
    
}

export default AddInputFormsForAnswersType3;